export const getPageNumberSectionText = (currentPage: number, entriesPerPage: number, totalEntries: number): string => {
  const firstEntryNumber = currentPage * entriesPerPage + 1;
  const lastEntryNumber = currentPage * entriesPerPage + entriesPerPage;

  return `Show ${firstEntryNumber} to ${
    lastEntryNumber < totalEntries ? lastEntryNumber : totalEntries
  } of ${totalEntries}`;
};

export const getCountPages = (totalEntries: number, entriesPerPage: number): number => {
  return Math.ceil(totalEntries / entriesPerPage) || 1;
};
